import useEmblaCarousel from 'embla-carousel-react';
import { NextButton, PrevButton, usePrevNextButtons } from './carousel-arrow-buttons';
import { Children, ReactNode } from 'react';
import { ReactComponent as Caret } from "../../assets/caret-right.svg";

export function SpeechCarousel({ children }: { children: ReactNode }) {

  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start"
  })
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = usePrevNextButtons(emblaApi)

  return (
    <div className="flex items-center mt-3">
      <PrevButton
        onClick={(event) => {
          event.stopPropagation();
          onPrevButtonClick();
        }}
        disabled={prevBtnDisabled}
      >
        <Caret className="w-[10px] stroke-red-400 rotate-180 translate-y-0 mr-0.5" />
      </PrevButton>
      <div className="overflow-hidden w-full mx-2" ref={emblaRef}>
        <div className="flex touch-pan-y touch-pinch-zoom m-0">
          {Children.map(children, (child, i) => {
            return (
              <div className="mr-2.5">
                {child}
              </div>
            )
          })}
        </div>
      </div>
      <NextButton
        onClick={(event) => {
          event.stopPropagation();
          onNextButtonClick();
        }}
        disabled={nextBtnDisabled}
      >
        <Caret className="w-[10px] stroke-red-400 ml-0.5" />
      </NextButton>
    </div>
  )
}
